/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
import { Vmo404SVGVerticle } from '../../../assets/404page';
import VmoGrid from '../../Collections/VmoGrid/VmoGrid';
import VmoGridColumn from '../../Collections/VmoGrid/VmoGridColumn';
import VmoHeader from "../../Elements/VmoHeader/VmoHeader"
import VmoButton from "../../Elements/VmoButton/VmoButton"
const Vmo404Verticle = ({ heading, subheader, btnLabel, onClick }) => {
    return (

        <VmoGrid padded verticalAlign="middle" textAlign="center" doubling relaxed style={{ minHeight: "100vh" }} >
            <VmoGridColumn verticalAlign="middle">
                <VmoHeader textAlign="center" content={heading} />
                <VmoHeader textAlign="center" subheader={subheader} />
                <VmoHeader as="div" textAlign="center" >
                    <Vmo404SVGVerticle />
                </VmoHeader>

                <VmoButton primary onClick={onClick} >
                    {btnLabel}
                </VmoButton>
            </VmoGridColumn>
        </VmoGrid>

    )
}

export default Vmo404Verticle

Vmo404Verticle.propTypes = {
    heading: PropTypes.string.isRequired,
    subheader: PropTypes.string,
    btnLabel: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

Vmo404Verticle.defaultProps = {
    heading: 'Sorry, the page is not found!',
    subheader: 'The page you are looking for does not exist or has been moved.',
    btnLabel: 'Go to Homepage',
    onClick: () => {
        window.location.href = '/';
    }
};